export default __webpack_public_path__ + "static/yoon-kam-fei-peppercloud-customer-14473601391abb85114f7c76eb77c709.png";